import { createFieldSelectorHook } from 'src/lib/sweetState';

import { CommonStore } from './CommonStore';

export const useIsAuthTokenGuardActive = createFieldSelectorHook(
  CommonStore,
  'authTokenGuardActive'
);
